import { proxyTable } from './proxy';
import { oldVersionProxy } from './defineProperty';
import { TDomainOpts } from '../domainFactory';

export default (opts: TDomainOpts, title) => {
  let reactiveModel = {};
  // 如果浏览器可用proxy则使用，否则用defineProperty
  if (typeof Proxy !== 'undefined') {
    // 监听表格内容，如果存在变更则及时本地存储，有效期为一次会话
    reactiveModel = proxyTable({ ...opts.table, ...opts.actions }, title);
  } else {
    reactiveModel = { ...opts.table, ...opts.actions };
    oldVersionProxy(reactiveModel, title);
  }

  return reactiveModel;
};
